module.exports = __webpack_public_path__ + "img/chevron-down--white.976254bb.svg";